/*

VueJs Gegenstück zur InlineTile.html aus Fluid


*/
<template>
    <div class="global-inline-tile">
        <div class="global-inline-tile__image" v-if="image || imageAlternative">
            <div v-if="image === 'placeholder'" class="global-inline-tile__placeholder" />
            <a v-else-if="image" :href="imageLink" :is="imageLink ? 'a' : 'span'">
                <img :src="image" width="68" :alt="title" />
            </a>
            <span v-else-if="imageAlternative" v-html="imageAlternative" />
        </div>

        <div class="global-inline-tile__content">
		        <a :is="titleLink ? 'a' : 'span'" :href="titleLink" class="global-inline-tile__title" v-html="title" />
            <span v-if="subtitle" class="global-inline-tile__subtitle" v-html="subtitle" />
            <span v-if="text" v-html="text" />
        </div>
    </div>

</template>

<script>
import GlobalResponsiveImage from "@global/global-elements/global-responsive-image/global-responsive-image.vue";

export default {
    name: "globalInlineTile",
    components: {GlobalResponsiveImage},
    props: {
        image: {
            type: Object|String
        },
        imageLink: {
            type: String
        },
        keepImageAspect: {
            type: Boolean,
            default: false
        },
        imageAlternative: {
            type: String
        },
        title: {
            type: String,
            required: true
        },
        titleLink: {
            type: String
        },
        subtitle: {
            type: String
        },
        text: {
            type: String
        },
    }
}
</script>
